/**
 * The browser half of the import file step: everything that touches a `File`
 * lives here, the rules live in `@splitfiesta/core` so mobile runs the same
 * ones over the text its document picker returns.
 */
import { readAndParseImportFile, validateImportFile } from '@splitfiesta/core';
import type { ImportFileResult, LabelResolutions } from '@splitfiesta/core';

export async function readImportFile(
  file: File,
  resolutions?: LabelResolutions
): Promise<ImportFileResult> {
  const rejected = validateImportFile({ name: file.name, size: file.size });
  if (rejected) return { error: rejected };

  let text: string;
  try {
    text = await file.text();
  } catch {
    return { error: { key: 'import:errors.parseFailed' } };
  }
  return readAndParseImportFile(text, resolutions);
}
